import React from "react";
import Input from "../../components/input";
import CommonButton from "../../components/commonButton";
import { routes } from "../../routes/PageRoutes";
import { NpaPropertiesList } from "../../components/TableHeadings";
import { ButtonGroup, OverlayTrigger, Table, Tooltip } from "react-bootstrap";
import TableImportImg from "../../assets/images/table/import.png";
import AddPropertyImg from "../../assets/images/table/plus.png";
import NoData from "../../components/no-data/index";
import moment from "moment";
import {EditIcon,FilterIcon,MepEyeIcon,MoreVerticalIcon} from "../../assets/icons";
import CommonActionDropDown from "../../components/common-action-dropdown";
import { Link } from "react-router-dom";
import { BankIcons, getUserInitial } from "../../components/common";
import ExportBtnWithIcon from "../../components/exportBtnWithIcon";
import StatusChip from "../../components/statusChip";
// import Select from 'react-select';

const PropertyList = ({
  data,
  // isEdit,
  navigate,
  currentPage,
  setCurrentPage,
  openDropdown,
  handleEditBtn,
  filterValues,
  setFilterValues,
  getCustomerActions,
  handleToggleDropdown,
  setFilterModal,
  handleExportNpaProperties,
  handleOpenImportModal
}) => {

  // Check if any value except 'search' is non-empty
  const isFilterActive = Object?.entries(filterValues)
  .filter(([key]) => key !== "search") // Exclude the 'search' key
  .some(([, value]) => value !== ""); // Check if any value is non-empty
  
  // console.log("isFilterActive",isFilterActive);

  return (
    // <div className="bg-white rounded-2 overflow-hidden common-shadow mt-5">
    <>
      <div className="p-4 d-flex align-items-center flex-wrap justify-content-between gap-3">
       <div className="d-flex  align-items-center gap-2">
       <Input
          type="search"
          value={filterValues?.search}
          placeholder="Search by Borrower Name"
          onChange={(e) => {
            setFilterValues((val) => ({
              ...val,
              search: e.target.value
            }))
            setCurrentPage(1);
          }}
          className="shadow-none base-search"
        />
          {/* btn-active --- Apply Filter Class */}
          <button onClick={() => setFilterModal(true)} className={`rounded-2 position-relative custom-filter-btn ${isFilterActive ? "btn-active" : ""}`}>
          <div className="d-flex gap-2 align-items-center justify-content-center ">
            <span><FilterIcon height={16} width={16} strokeWidth="1.5" color="" /></span>
            <p>Filter</p>
          </div>
          </button>
        </div>  

        <div className="action-buttons-container">
          <CommonButton
            icon={<span><img src={TableImportImg} alt="import" /></span>}
            className="btn-primary-light me-2"
            title="Import"
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              handleOpenImportModal();
            }}
          />
          <ExportBtnWithIcon title="Export" type="button" onClick={handleExportNpaProperties}
          />
          <CommonButton
            icon={<span><img src={AddPropertyImg} alt="import" /></span>}
            className="btn-primary"
            title="Add Property"
             type="button"
            onClick={(e) => {
              e.stopPropagation();
              navigate(routes.addNpaProperties);
            }}
          />
        </div>
      </div>

      <Table responsive className="common-table">
        <thead>
          <tr>
            {NpaPropertiesList?.map((column, index) => (
              <th key={index}>{column.label}</th>
            ))}
          </tr>
        </thead>

        <tbody>
          {data?.length === 0 ? (
            <NoData/>
          ) : (
            data?.map((item, i) => (
              <tr
                className="cursor-pointer"
                key={item?.id}
                onClick={(e) => {
                  e.stopPropagation();
                  navigate(`/npa-properties/property-details/${item.id}`,{state:{currentPage:currentPage}});
                }}
              >
                <td className="id">{item?.property_number_id ? `# ${item?.property_number_id}` : "-"}</td>
                <td>
                  <div className="d-flex align-items-center gap-2">
                    <div className="profile-icon">
                      {item?.borrower_names &&
                        getUserInitial(item?.borrower_names)}
                    </div>
                    <div className="ms-1">
                      <p className="fw-medium text-capitalize">
                        {item?.borrower_names ? item?.borrower_names : "-"}
                      </p>
                    </div>
                  </div>
                </td>
                <td className="text-start">{item?.Bank && item?.Bank?.bank_name ? <>{BankIcons(item?.Bank?.bank_name, { style: { width: '16px', height: '16px' }})}{" "} {item?.Bank?.bank_name}</> : "-"}</td>
                <td className="text-start">{item?.reserve_price ? `₹ ${item?.reserve_price}` : ""}</td>

                <td className="text-start">
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                    <span>{item?.auction_start_time ? moment(item.auction_start_time).format("DD MMM YYYY") : ""}</span>
                    <span>{item?.auction_start_time ? moment(item.auction_start_time).format("hh:mm A") : ""}</span>
                  </div>
                </td>

                <td className="text-start">
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
                    <span>{item?.auction_end_time ? moment(item.auction_end_time).format("DD MMM YYYY") : ""}</span>
                    <span>{item?.auction_end_time ? moment(item.auction_end_time).format("hh:mm A") : ""}</span>
                  </div>
                </td>

                <td>{item?.status ? (<StatusChip pill title={item?.status} className="text-capitalize" bg={item?.status === "upcoming" ? "chip-ornage" : item?.status === "live" ? "chip-green" : item?.status === "expired" ? "chip-red" : "custom-status-chip"}/>) : ("-")}</td>
                <td>{item?.assetCategory ? item?.assetCategory?.name : "-"}</td>
                <td>{item?.possessionType ? <StatusChip bg={"chip-green"} pill title={item?.possessionType?.name} className="text-capitalize"/> : ""}</td>
                <td>{item?.propertyType ? <StatusChip bg={"chip-green"} pill title={item?.propertyType?.name} className="text-capitalize"/> : ""} </td>
                <td>{item?.inquiry_count ? item?.inquiry_count : "-"}</td>
                {/* <td>-</td> */}
                <td onClick={(e) => e.stopPropagation()}>
                  <OverlayTrigger placement="top" overlay={<Tooltip id={`tooltip-top`}>Edit</Tooltip>} >
                  <span onClick={() => handleEditBtn(item)} className="mx-2">
                    <EditIcon
                      width={20}
                      height={20}
                      color="#6D6B77"
                      strokeWidth="4"
                    />
                  </span>
                </OverlayTrigger>
                <OverlayTrigger placement="top" overlay={<Tooltip id={`tooltip-top`}>View</Tooltip>} >
                  <Link to={`/npa-properties/property-details/${item.id}`}>
                    <MepEyeIcon
                      width={20}
                      height={20}
                      color="#6D6B77"
                      strokeWidth="4"
                    />
                  </Link>
                  </OverlayTrigger>
                  <CommonActionDropDown
                    as={ButtonGroup}
                    id={`dropdown-basic-${i}`}
                    icon={
                      <MoreVerticalIcon
                        width={20}
                        height={20}
                        color="#6D6B77"
                        strokeWidth="4"
                      />
                    }
                    actions={getCustomerActions(item)}
                    show={openDropdown === i}
                    onToggle={() => handleToggleDropdown(i)}
                    className="action-menu"
                  />
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>

      {/* <div className="p-3 mx-1 d-flex flex-wrap align-items-center justify-content-between gap-4">
        <p className="custom-table-infotext ">
          {/* Displaying {currentPage * limit?.value + 1} to{" "}
        {Math.min((currentPage + 1) * limit?.value, total)} of {total}{" "} */}
      {/* Displaying */}
      {/* </p> */}
      {/* <div className="d-flex gap-4"> */}
      {/* {totalPages > 1 ? (
          <> */}
      {/* <CreatableSelect
              isClearable
              options={recordsPerPageOptions}
              value={limit}
              onChange={handleChange}
              placeholder="Select or create"
              menuPortalTarget={document.body} // Render the menu at the body level
              menuPlacement="top" // Display the options above the input
              styles={{
                control: (base) => ({
                  ...base,
                  width: "170px", // Fixed width for the input field
                }),
                menu: (base) => ({
                  ...base,
                  width: "170px", // Fixed width for the dropdown menu
                }),
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999, // Ensure it appears above everything
                }),
              }}
            /> */}

      {/* <CommonPagination
              totalItems={total}
              itemsPerPage={limit?.value}
              currentPage={currentPage + 1}
              onPageChange={handlePageChange}
            /> */}
      {/* </>
        ) : null} */}
      {/* </div> */}
      {/* // </div> */}
    </>
    // </div>
  );
};

export default PropertyList;
